module.exports = __webpack_public_path__ + "static/media/Card - Sunday School.323baa9a.png";